//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "AquisitionDisposition",
	props: {
		settings: Object
	},
	watch: {
		settings: function settings(newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal) {
					this.data = newVal;
				}
			}
		}
	},
	data: function data() {
		return {
			modalName: 'aquisition-disposition',
			selled: false,
			working: false,
			data: {
				purchase_date: null,
				disposition_date: null,
				disposition_fullname: null,
				sold: false,
				archive: false
			},
			flatPickrConfig: {
				dateFormat: 'Y-m-d'
			}
		};
	},
	mounted: function mounted() {
		var _this = this;

		Event.$on('aquisition-disposition', function () {
			Event.$emit('open-slide', _this.modalName);
		});

		Event.$on('close-slide', function () {
			_this.selled = false;
		});
	},

	methods: {
		cancel: function cancel() {
			Event.$emit('close-slide', this.modalName);
		},
		save: function save() {
			var _this2 = this;

			this.working = true;

			var payload = { propertyId: this.$store.state.selectedProperty };
			axios.post('/prototype/properties/offboard', payload).then(function () {
				_this2.load();

				_this2.working = false;
			}).then(function (response) {
				_this2.$snotify.success("Property has been offboarded successfully.");
			}).then(function (response) {
				location.reload();
			});
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/settings/AquisitionDispositionSettings.vue
// module id = MiPz
// module chunks = 0 1